import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  quote: string;
  imageIndex: number;
}
export function TestimonialCard({
  name,
  quote,
  imageIndex
}: TestimonialCardProps) {
  // Using a placeholder avatar service that generates realistic looking faces
  const avatarUrl = `https://i.pravatar.cc/150?img=${imageIndex}`;
  return <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col h-full" data-id="element-18">
      <div className="flex items-center gap-1 mb-4 text-yellow-400" data-id="element-19">
        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-20" />)}
      </div>
      <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-21">"{quote}"</p>
      <div className="flex items-center gap-3 mt-auto" data-id="element-22">
        <img src={avatarUrl} alt={name} className="w-12 h-12 rounded-full object-cover border-2 border-orange-100" data-id="element-23" />
        <span className="font-semibold text-gray-900" data-id="element-24">{name}</span>
      </div>
    </div>;
}